var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { DottedLine, EntityValue, useChat, useLang, useLink } from '@shapeable/ui';
import { applyPseudoEntityTypeName, classNames } from '@shapeable/utils';
import { pickBy, size, uniqBy } from 'lodash';
var cls = classNames('gpt-source-list');
export var GptSourceListDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a {\n      text-decoration: none;\n    } \n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: ", ";\n  "], ["\n    a {\n      text-decoration: none;\n    } \n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var DottedLineStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var EntityStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    // background: ", ";\n  "], ["\n    color: ", ";\n    // background: ", ";\n  "])), theme.COLOR("strong"), theme.COLOR(""))
});
var LabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 500;\n  "], ["\n    color: ", ";\n    font-weight: 500;\n  "])), theme.COLOR("dark"))
});
var SourceListStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    a:hover {\n      color: ", ";\n\n      .shp--entity-value {\n        color: ", ";\n      }\n    }\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: ", ";\n  "], ["\n    a:hover {\n      color: ", ";\n\n      .shp--entity-value {\n        color: ", ";\n      }\n    }\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: ", ";\n  "])), theme.COLOR("primary"), theme.COLOR("primary"), theme.UNIT(5))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  DottedLine: styled(DottedLine)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DottedLineStyles),
  Label: styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  SourceList: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SourceListStyles),
  Entity: styled(EntityValue)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), EntityStyles)
};
export var GptSourceList = function (props) {
  var className = props.className,
    items = props.items;
  var t = useLang();
  var Link = useLink().Link;
  var chat = useChat();
  var messageSources = uniqBy((items || []).map(function (source) {
    var _a;
    var name = source.name;
    if (source.__typename === 'WebPage' && !source.name) {
      try {
        var url = new URL(source.source);
        name = url.hostname;
      } catch (e) {
        // fallback to original source if URL parsing fails
        name = source.source;
      }
    }
    return {
      __typename: source.__typename || 'Entity',
      id: source.slug,
      slug: source.slug,
      name: name,
      path: source.path,
      href: source.source,
      /* @ts-ignore */
      __type: source.__typename,
      __meta: {
        sourceType: source.sourceType
      },
      // size pickBy ensures that empty objects are not included in the result (server returns an empty object for image, but it should ideally be null)
      openGraph: __assign(__assign({}, pickBy(source.openGraph, function (item) {
        return size(item);
      }) || {}), {
        url: ((_a = source.openGraph) === null || _a === void 0 ? void 0 : _a.url) || source.source
      })
    };
  }), 'href').map(applyPseudoEntityTypeName);
  if (!messageSources.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.DottedLine, {
    gap: 5
  }), React.createElement(My.Label, null, t('Sources:')), React.createElement(My.SourceList, null, messageSources.map(function (source, index) {
    var _a, _b;
    return React.createElement(Link, {
      key: "".concat(source.id, "-").concat(index),
      href: source.__type === "Citation" ? ((_a = source.openGraph) === null || _a === void 0 ? void 0 : _a.url) || source.path : source.path || ((_b = source.openGraph) === null || _b === void 0 ? void 0 : _b.url)
    }, React.createElement(My.Entity, {
      imageStyle: source.__type === 'Organisation' ? 'logo' : 'default',
      variant: 'small',
      key: source.id,
      entity: source
    }));
  })));
};
GptSourceList.cls = cls;
GptSourceList.defaultProps = GptSourceListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;